import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const BrokenImageIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5v-4.58l.99.99 4-4 4 4 4-3.99L19 12.43zm0-9.41-1.01-1.01-4 4.01-4-4-4 4-.99-1V5h14z"
    />
  </BaseIcon>
)
